var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","min-height":"100vh"}},[_c('iframe',{staticStyle:{"position":"relative","top":"0","left":"0","width":"100%","height":"1150px"},attrs:{"src":"https://survey.alchemer.com/s3/6922484/TOU","frameborder":"0","allowfullscreen":""}})])
}]

export { render, staticRenderFns }